import { INSURANCE_TYPES } from '../../../constants';
import type { ContentData } from '../types';

const data: ContentData = {
  meta: {
    description:
      'Need travel insurance for your New Zealand trip? Get coverage for cancellations, surprise medical expenses, ski cover and more with ahm. Get a quote today!',
    title: 'New Zealand Travel Insurance - ahm Travel insurance',
  },
  sections: [],
  type: INSURANCE_TYPES.TRAVEL,
};

export default data;
